import { Action } from 'redux'
import { TemplatesActions } from '../../reducers/templates/actionNames'
import { ITemplate } from '../../models/Templates'

export const requestTemplates = (): IRequestTemplates => ({
  type: TemplatesActions.RequestForTemplates,
})
export const acceptTemplates = (
  templates: ITemplate[],
  grouped: any,
): IAcceptTemplates => ({
  grouped,
  templates,
  type: TemplatesActions.TemplatesAreAccepted,
})

export const rejectTemplates = (errMessage: string): IRejectTemplates => ({
  errMessage,
  type: TemplatesActions.TemplatesAreRejected,
})

export type IRequestTemplates = Action<TemplatesActions.RequestForTemplates>

export interface IAcceptTemplates
  extends Action<TemplatesActions.TemplatesAreAccepted> {
  templates: ITemplate[]
  grouped: any
}

export interface IRejectTemplates
  extends Action<TemplatesActions.TemplatesAreRejected> {
  errMessage: string
}
